import { Selector } from '@ngxs/store';
import { NotificationInboxState, NotificationInboxStateModel } from './notification-inbox.state';

export class NotificationInboxSelectors {
  @Selector([NotificationInboxState])
  static items(state: NotificationInboxStateModel) {
    return state.items;
  }

  @Selector([NotificationInboxState])
  static loading(state: NotificationInboxStateModel) {
    return state.loading;
  }

  @Selector([NotificationInboxState])
  static unreadCount(state: NotificationInboxStateModel) {
    return state.unreadCount;
  }

  @Selector([NotificationInboxState])
  static counts(state: NotificationInboxStateModel) {
    return state.counts;
  }

  @Selector([NotificationInboxState])
  static loadingMore(state: NotificationInboxStateModel) {
    return state.loadingMore;
  }

  @Selector([NotificationInboxState])
  static haveNext(state: NotificationInboxStateModel) {
    return state.haveNext;
  }

  @Selector([NotificationInboxState])
  static loadError(state: NotificationInboxStateModel) {
    return state.loadError;
  }

  @Selector([NotificationInboxState])
  static loadMoreError(state: NotificationInboxStateModel) {
    return state.loadMoreError;
  }
}
